import { AnimatePresence, motion, Reorder } from "framer-motion";
import { GameObject } from "@needle-tools/engine";
import { CameraManager } from "../../CameraManager";
import { useRaceOrder } from "../RaceOrderProvider";
import { RaceOrderSlip } from "./RaceOrderSlip";
import { cn } from "../../../utils/helper-funcs";

interface RaceOrderProps {
  className?: string;
  setCurrentHorse: (horse: string) => void;
}

export function RaceOrder({ className, setCurrentHorse }: RaceOrderProps) {
  const { raceOrder, setRaceOrder } = useRaceOrder();
  // const mockRaceOreder = [
  //   { racerName: "Canada", racerNumber: 1 },
  //   { racerName: "Japan", racerNumber: 2 },
  //   { racerName: "Spain", racerNumber: 3 },
  //   { racerName: "France", racerNumber: 4 },
  //   { racerName: "Peru", racerNumber: 5 },
  //   { racerName: "Chile", racerNumber: 6 },
  // ];

  const handleClick = (idx: number) => {
    const cameraManager = GameObject.findObjectOfType(CameraManager);

    cameraManager?.focusOnRacerJS(idx);
  };

  return true ? (
    <AnimatePresence>
      <motion.div
        initial={{ x: 100, opacity: 0 }}
        exit={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5, ease: "linear" }}
        className={cn("h-full md:h-1/2 ", className)}
      >
        <Reorder.Group
          axis="y"
          values={raceOrder}
          onReorder={setRaceOrder}
          className="h-full"
        >
          <ul className="flex flex-col items-end justify-center h-full gap-1">
            {raceOrder.map((racer, idx) => (
              <RaceOrderSlip
                key={racer.racerName}
                racer={racer}
                idx={idx}
                onClick={handleClick}
              />
            ))}
          </ul>
        </Reorder.Group>
      </motion.div>
    </AnimatePresence>
  ) : null;
}
